import React from "react";
import { Link } from "react-router-dom";
import logoBase from "../images/logo/logo.png";
import { SquareMenu } from "lucide-react";

function HeaderTitle() {
  return (
    <Link className="navbar-brand" to="/">
      <img
        src={logoBase}
        className="headerLogo"
        alt="App Logo"
        loading="lazy"
      />
    </Link>
  );
}

function HeaderLinksDesktop({ links }) {
  return (
    <ul className="navbar-nav ml-auto d-flex flex-row w-50 justify-content-evenly d-none d-lg-flex d-md-none">
      {links.map((link, index) => (
        <LinkMapAndCreate key={index} {...link} />
      ))}
    </ul>
  );
}

function HeaderLinkMobile({links}){
  return (
    <ul className="navbar-nav ml-auto d-flex flex-row d-md-flex d-lg-none d-sm-flex d-xl-none">
      <li className="nav-item dropdown">
        <a
          className="nav-link text-white"
          href="/#"
          id="navbarDropdownMenuLink"
          role="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <SquareMenu />
        </a>
        <ul className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
          {links.map((link, index) => (
            <LinkMapAndCreate key={index} {...link} />
          ))}
        </ul>
      </li>
    </ul>
  );
}

function LinkMapAndCreate({ link, text }) {
  const isInternalLink = /^\/(?!\/)/.test(link);
  if (isInternalLink) {
    return (
      <li className="nav-item">
        <Link to={link} className="dropdown-item">
          <span className="dropItem">{text}</span>
          <span className="dropFang"></span>
        </Link>
      </li>
    );
  } else {
    return (
      <li className="nav-item">
        <a href={link} className="dropdown-item">
          <span className="dropItem">{text}</span>
          <span className="dropFang"></span>
        </a>
      </li>
    );
  }
}

function Header({ title, dropDownText, dropDownLinks }) {
  return (
    <header>
      <nav className="navbar sticky-top navbar-expand-md navbar-dark bg-black-custom text-light">
        <div className="container">
          <HeaderTitle title={title} />
          <HeaderLinksDesktop links={dropDownLinks} />
          <HeaderLinkMobile links={dropDownLinks}/>
        </div>
      </nav>
    </header>
  );
}

export default Header;
